var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "uk1bfv6k2a",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s971ajqzxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uk1bfv6k2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.464 19.271 6.268-6.449a.988.988 0 0 1 1.397-.02l.042.043a1 1 0 0 1 .003 1.397L10.55 19 32.187 19a1 1 0 1 1 0 2H10.589l4.585 4.717a1 1 0 0 1-.003 1.397l-.025.025a.988.988 0 0 1-1.397.014l-.017-.017-6.22-6.398a1.005 1.005 0 0 1-.214-.278l-.018-.037a.982.982 0 0 1-.097-.376v-.135a.996.996 0 0 1 .281-.641z",
    fill: "#FFF",
    mask: "url(#s971ajqzxb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavLeft);
export default __webpack_public_path__ + "static/media/icon-nav-left.72db75d9f10d7f331a68369bcc77be52.svg";
export { ForwardRef as ReactComponent };